{
  "sitemaps": {
    "title": "Mapas del sitio",
    "page_content": "Los mapas del sitio permiten integrar dibujos CAD detallados de los lugares o ubicaciones en el mapa. Puedes añadir y gestionar mapas del sitio y dibujos CAD a continuación.",
    "no_sitemaps_title": "Aquí está un poco vacío...",
    "no_sitemaps_body_1": "¡Actualmente no hay ubicaciones clave ni mapas del sitio! Haga clic en ",
    "no_sitemaps_body_2": " botón para agregar tantas ubicaciones como desee",
    "add_sitemap": "Agregar mapa del sitio",
    "create_sitemap_comming_soon_message": "La carga automática de dibujos CAD estará disponible próximamente. Mientras tanto, nuestro equipo de soporte puede subir tus CAD por ti.",
    "click_to_open_sitemap_options": "Haz clic para abrir las opciones del mapa del sitio",
    "edit_sitemap": "Editar mapa del sitio",
    "delete_sitemap": "Eliminar mapa del sitio"
  },
  "user_settings": "Configuración de usuario",
  "help": "Ayuda",
  "help_menu": {
    "title": "Ayuda y recursos",
    "getting_started": "Cómo empezar con Iventis",
    "knowledge_base": "Base de conocimientos de Iventis",
    "support": "Soporte",
    "about": "Acerca de Iventis"
  },
  "sso": {
    "title": "Configuración de SSO",
    "page_content": "Aquí puede editar la configuración de SSO del proyecto",
    "response_signing_certificate": "Certificado de firma de respuesta",
    "meta_data_location": "URL de metadatos del proveedor de identidad",
    "identity_provider": "ID de entidad del proveedor de identidad",
    "saved": "La configuración de SSO se guardó correctamente",
    "setup_description": "Al configurar el SSO con tu proveedor de identidad, tendrás que seleccionar SAML e introducir las siguientes propiedades",
    "entity_id": "ID de entidad",
    "rely_url": "URL de respuesta",
    "signon_url": "URL de inicio de sesión",
    "sso_enabled": "SSO habilitado",
    "enable_confirmation": "¿Estás seguro de que deseas habilitar el SSO para este proyecto?",
    "enable_confirmation_warning": "Asegúrese de que el SSO esté configurado correctamente antes de habilitarlo para evitar que los usuarios no puedan participar en el proyecto",
    "disable_confirmation": "¿Está seguro de que desea deshabilitar el SSO para este proyecto?",
    "disable_confirmation_warning": "Para deshabilitar el SSO, todos los usuarios que actualmente dependen del SSO deberán establecer una contraseña. Recibirán un correo electrónico con instrucciones para crear su contraseña a fin de mantener el acceso al proyecto.",
    "disable_confirmation_warning2": "Una vez que se desactive el SSO, para volver a habilitarlo será necesario reactivar manualmente el acceso al SSO para cada usuario."
  },
  "projectCustomisation": {
    "projectNameWarning": "Si se cambia el nombre del proyecto, se modificará lo siguiente:",
    "projectNameWarningSsoKey": "Así que:",
    "projectNameWarningSsoValue": "URL de configuración (si está habilitada)",
    "projectNameWarningUrlKey": "URL del proyecto:"
  },
  "projectRolePermissions": {
    "projectAdministratorsSubMenu": "Administradores del proyecto",
    "projectAdministratorsTitle": "Administradores de proyectos",
    "projectAdminRoleDescription": "Aquí puede añadir o eliminar administradores de proyectos. Estos usuarios tienen acceso a todos los datos, ajustes y permisos del proyecto y pueden editarlos.",
    "addAdmin": "Agregar usuario",
    "addProjectAdmin": "Agregar administrador del proyecto",
    "removeAdmin": "Eliminar el estado de administrador",
    "removeAdminConfirm": "Esta persona ya no será administradora del proyecto. ¿Desea continuar?",
    "removeYourselfAdminConfirm": "Perderás el acceso de administrador del proyecto y no podrás volver a agregarlo. ¿Desea continuar?",
    "projectAdminsSelectedConfirmButton": "Agregar seleccionado",
    "addAdminsToast": "Los administradores se agregaron correctamente",
    "removeAdminToast": "El administrador se eliminó correctamente"
  }
}